/**
 * Serviço para gerenciar o status do documento da aplicação
 */

const DOCUMENT_STATUS_KEY = 'vmvpd_document_status';

export type DocumentStatus = "active" | "inactive";

/**
 * Armazena o status do documento no localStorage
 * @param status - O status do documento a ser armazenado
 */
export const setDocumentStatus = (status: DocumentStatus): void => {
  try {
    localStorage.setItem(DOCUMENT_STATUS_KEY, status);
  } catch (error) {
    console.error('Erro ao armazenar status do documento:', error);
  }
};

/**
 * Recupera o status do documento do localStorage
 * @returns O status do documento armazenado ou null se não existir
 */
export const getDocumentStatus = (): DocumentStatus | null => {
  try {
    const status = localStorage.getItem(DOCUMENT_STATUS_KEY);
    return status as DocumentStatus | null;
  } catch (error) {
    console.error('Erro ao recuperar status do documento:', error);
    return null;
  }
};

/**
 * Remove o status do documento do localStorage
 */
export const clearDocumentStatus = (): void => {
  try {
    localStorage.removeItem(DOCUMENT_STATUS_KEY);
  } catch (error) {
    console.error('Erro ao remover status do documento:', error);
  }
};

